import React, { useEffect, useState } from "react";
import { pushFirebase, updateUserInRoomList, fetchFirebase } from "./firebaseCRUD";
import { useSelector, useDispatch } from "react-redux";
import { snapshotToArray } from "./ChatScripts";
import { setChatSettings, setIsChatOpen } from "../../../../appRedux/actions/ChatSettings";
import { v4 as uuidv4 } from "uuid";
import { Button } from "../../../BP2Components";
import IntlMessages from "../../../../util/IntlMessages";
import { isInNuxtContext } from "../../../FormsV2/GeneralScripts";

const CreateChatInMessage = ({
   currentProcessStep,
   windowWidth,
   chatTitle,
   usersToAdd,
   setIsChatSetModalOpen,
   customTitle,
}) => {
   const [privateRooms, setPrivateRooms] = useState([]);
   const [titleValue, setTitleValue] = useState(customTitle ?? "");

   const chatSettings = useSelector(({ chatSettings }) => chatSettings);
   const { id, oldId } = useSelector(({ user }) => user);

   const dispatch = useDispatch();
   const roomId = uuidv4();

   useEffect(() => {
      fetchFirebase("rooms/").on("value", (resp) => {
         setPrivateRooms([]);
         setPrivateRooms(
            snapshotToArray(resp)?.filter(
               (singleRoom) => singleRoom.type === "private" && singleRoom.status !== "archived",
            ),
         );
      });
   }, []);

   useEffect(() => {
      if (chatTitle || usersToAdd) {
         setTitleValue(chatTitle ? chatTitle : chatSettings?.currentRoom?.id);
      }
   }, [usersToAdd, chatSettings?.currentRoom?.id, chatTitle]);

   const createChat = () => {
      // If we're in Nuxt context and have currentProcessStep, emit event to open Vue chat
      if (isInNuxtContext() && currentProcessStep) {
         const event = new CustomEvent("nuxt:open-case-chat", {
            detail: {
               mainInstanceId: String(currentProcessStep.instanceId),
               title: titleValue || currentProcessStep?.name || chatTitle || "Chat",
            },
         });
         window.dispatchEvent(event);
         setIsChatSetModalOpen && setIsChatSetModalOpen(false);
         return;
      }

      // Legacy Firebase chat logic (for non-Nuxt contexts)
      let caseReference;
      if (currentProcessStep) {
         caseReference = `${currentProcessStep?.instanceId}-${id}`;
      } else if (chatTitle || usersToAdd) {
         caseReference = usersToAdd.join("-");
         setTitleValue(chatTitle ? chatTitle : chatSettings?.currentRoom?.id);
      }

      const createdPrivateRoom = privateRooms.find((room) => room.caseReference === caseReference);

      let usersArray;
      if (createdPrivateRoom?.chatUsers) {
         usersArray = createdPrivateRoom?.chatUsers;
      } else if (usersToAdd) {
         usersArray = usersToAdd;
         chatSettings?.SelectedUserId && usersArray.push(chatSettings?.SelectedUserId);
         setIsChatSetModalOpen(false);
      } else {
         usersArray = [];
      }
      let sortedUsersArray = [];
      usersArray.push(oldId);
      sortedUsersArray = [...new Set(usersArray)];
      const clearedUsersArray = sortedUsersArray.filter((user) => user !== undefined);

      if (createdPrivateRoom) {
         updateUserInRoomList("rooms", createdPrivateRoom.key, clearedUsersArray.sort());
         dispatch(
            setChatSettings({
               ...chatSettings,
               currentRoom: createdPrivateRoom,
            }),
         );
      } else {
         const newRoom = pushFirebase("rooms/");
         newRoom.set({
            id: roomId,
            title: titleValue !== null ? titleValue : "Set Room Title",
            subTitle: currentProcessStep?.instanceId
               ? currentProcessStep?.instanceId
               : "Set Room Sub Title",
            caseReference: caseReference,
            type: "private",
            status: "active",
            seenBy: [oldId],
            chatUsers: usersArray,
            chatMessage: [],
            instanceId: currentProcessStep?.instanceId ? currentProcessStep?.instanceId : null,
         });
         dispatch(
            setChatSettings({
               ...chatSettings,
               currentRoom: {
                  id: roomId,
                  title: titleValue !== null ? titleValue : "Set Room Title",
                  subTitle: currentProcessStep?.instanceId
                     ? currentProcessStep?.instanceId
                     : "Set Room Sub Title",
                  caseReference: caseReference,
                  type: "private",
                  status: "active",
                  seenBy: [oldId],
                  chatUsers: usersArray,
                  chatMessage: [],
                  instanceId: currentProcessStep?.instanceId
                     ? currentProcessStep?.instanceId
                     : null,
               },
            }),
         );
      }

      if (chatSettings?.isChatOpen === false) {
         dispatch(setIsChatOpen(true));
      }

      setIsChatSetModalOpen && setIsChatSetModalOpen(false);
   };
   const renderChatButton = () => {
      return (
         <Button
            buttonType="primary"
            onClick={(e) => createChat()}
            size={!currentProcessStep ? "large" : windowWidth > 933 ? "middle" : "small"}
            style={{ minWidth: `${windowWidth > 933 ? "120px" : "100px"}`, margin: "0 5px" }}
            className="create-chat-in-message-btn"
         >
            {currentProcessStep ? (
               <IntlMessages id={"chat"} />
            ) : (
               <IntlMessages id={"createNewPrivateChat"} />
            )}
         </Button>
      );
   };

   return renderChatButton();
};

export default CreateChatInMessage;
